import { render, staticRenderFns } from "./ProxySettingsInput.vue?vue&type=template&id=79a8b1fa&scoped=true&lang=html"
import script from "./ProxySettingsInput.vue?vue&type=script&lang=js"
export * from "./ProxySettingsInput.vue?vue&type=script&lang=js"
import style0 from "./ProxySettingsInput.vue?vue&type=style&index=0&id=79a8b1fa&prod&lang=scss"
import style1 from "./ProxySettingsInput.vue?vue&type=style&index=1&id=79a8b1fa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79a8b1fa",
  null
  
)

export default component.exports